export default __webpack_public_path__ + "static/nintendo_assets-571e03c58ddeb8ea17ac9c94d05ea3cb.png";